<template>

    <div>
        <settingsNav></settingsNav>
        <v-container>

            <v-layout row wrap>

                <v-flex xs12 sm12 mb-2>

                    <v-btn class="secondary white--text" @click.stop="openSupplierDialog(null)">
                        New Supplier
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>

                </v-flex>

            </v-layout>

            <v-layout row wrap>

                <v-flex xs12 sm12>
                    <v-layout row>
                        <v-flex xs12>

                            <v-card>
                                <v-card-title>
                                    <v-card-title class="headline">
                                        Suppliers
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                        :headers="headers"
                                        :items="getSuppliers"
                                        :pagination.sync="pagination"
                                        :total-items=total
                                        class="elevation-0"
                                        :loading="loading"
                                        :rows-per-page-items="rowsPageItems"
                                >

                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                            <span>
                                          {{ props.header.text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                      <v-touch tag="tr"
                                               @doubletap="openSupplierDialog(props.item.id)"
                                               @dblclick="openSupplierDialog(props.item.id)">
                                            <td>{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left">{{ props.item.website }}</td>
                                            <td class="text-xs-left">{{ props.item.email }}</td>
                                      </v-touch>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>

                    </v-layout>


                    <addSupplierDialog></addSupplierDialog>


                </v-flex>
            </v-layout>

        </v-container>

    </div>


</template>

<script>
    import {
        Settings,
        ContactPersonSettings
    } from '../../../store/namespace-helper'
    import addSupplierDialog from '../Suppliers/AddSupplierDialog.vue'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'suppliers',
      components: {
        addSupplierDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Supplier-ID', value: 'id'},
                    {text: 'Company Name', value: 'name'},
                    {text: 'Website', value: 'website'},
                    {text: 'E-Mail', value: 'email'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadSuppliers()
      },
      methods: {
        openSupplierDialog (val) {
          if (val !== null) {
            let item = this.getSuppliers.find(x => x.id === val)
            this.$store.dispatch(Settings.actions.setSelectedSupplier, item)
          }
          this.$store.dispatch(Settings.actions.openCloseNewSupplierDialog)
        },
        loadSuppliers: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(Settings.actions.loadSuppliers, query)
        },
        throttledLoadSuppliers: _.debounce(function () {
          this.loadSuppliers()
        }, 450)
      },
      computed: {
        getSuppliers () {
          this.total = this.$store.getters[Settings.getters.getSuppliers].total
          return this.$store.getters[Settings.getters.getSuppliers].data
        },
        dialogState () {
          return this.$store.getters[Settings.getters.getOpenNewSupplierDialogState]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadSuppliers()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadSuppliers()
          },
          deep: true
        },
        dialogState: {
          handler (val) {
            if (!val) {
                        // cleanup states
              this.$store.dispatch(ContactPersonSettings.actions.setContactPersons, [])
                        // reload supplier list
              this.throttledLoadSuppliers()
            }
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Suppliers/Suppliers.vue